/**
 * @generated SignedSource<<4b5b71238891828cbff78702590ced84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InitiatedBy = "BITPANDA_CORPORATE_ACTION" | "BITPANDA_MANUAL_TRADE" | "BITPANDA_SAVINGS" | "BITPANDA_SWAPS" | "ORDER" | "OTHER" | "USER";
export type TransactionCategory = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NON_USER_INITIATED" | "STAKING" | "TRADE";
export type TransactionDirection = "INCOMING" | "OUTGOING";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type TransactionType = "BUY" | "SELL";
export type TransactionsListInput = {
  after?: string | null | undefined;
  assetId?: string | null | undefined;
  before?: string | null | undefined;
  category?: TransactionCategory | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  type?: TransactionType | null | undefined;
};
export type TransactionsViewQuery$variables = {
  input?: TransactionsListInput | null | undefined;
};
export type TransactionsViewQuery$data = {
  readonly transactions: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly __typename: string;
        readonly asset: {
          readonly __typename: string;
          readonly id: string;
          readonly logoUrl: string | null | undefined;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly assetAmount: PrecisionFloat | null | undefined;
        readonly assetPrice?: PrecisionFloat | null | undefined;
        readonly category: TransactionCategory;
        readonly childrenTransactions?: ReadonlyArray<{
          readonly asset: {
            readonly __typename: string;
            readonly logoUrl: string | null | undefined;
            readonly name: string | null | undefined;
            readonly symbol: string | null | undefined;
          } | null | undefined;
          readonly assetAmount: PrecisionFloat | null | undefined;
          readonly assetPrice?: PrecisionFloat | null | undefined;
          readonly direction: TransactionDirection | null | undefined;
          readonly fiatAmount: PrecisionFloat | null | undefined;
          readonly finalRevenueShare?: PrecisionFloat | null | undefined;
          readonly id: string;
          readonly initiatedBy: InitiatedBy | null | undefined;
          readonly offer?: {
            readonly id: string;
          } | null | undefined;
          readonly status: TransactionStatus | null | undefined;
          readonly time: TimeScalar | null | undefined;
        }> | null | undefined;
        readonly direction: TransactionDirection | null | undefined;
        readonly fiatAmount: PrecisionFloat | null | undefined;
        readonly id: string;
        readonly initiatedBy: InitiatedBy | null | undefined;
        readonly offer?: {
          readonly id: string;
        } | null | undefined;
        readonly parentId: string;
        readonly status: TransactionStatus | null | undefined;
        readonly time: TimeScalar | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type TransactionsViewQuery = {
  response: TransactionsViewQuery$data;
  variables: TransactionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initiatedBy",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetPrice",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "BuyTransaction",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "SellTransaction",
  "abstractKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TransactionOffer",
    "kind": "LinkedField",
    "name": "offer",
    "plural": false,
    "selections": [
      (v6/*: any*/)
    ],
    "storageKey": null
  }
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "DepositTransaction",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "WithdrawalTransaction",
  "abstractKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalRevenueShare",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "MergerCryptoTransaction",
  "abstractKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionsConnection",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "childrenTransactions",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SwapTransaction",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "childrenTransactions",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v18/*: any*/),
                          (v13/*: any*/),
                          (v27/*: any*/),
                          (v19/*: any*/),
                          (v26/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MergerCryptoTransaction",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionsConnection",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "childrenTransactions",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SwapTransaction",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "childrenTransactions",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v18/*: any*/),
                          (v13/*: any*/),
                          (v27/*: any*/),
                          (v19/*: any*/),
                          (v29/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MergerCryptoTransaction",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4520c7c54dedc712ee68d2ced2bab07d",
    "id": null,
    "metadata": {},
    "name": "TransactionsViewQuery",
    "operationKind": "query",
    "text": "query TransactionsViewQuery(\n  $input: TransactionsListInput\n) {\n  transactions(input: $input) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        __typename\n        id\n        parentId\n        time\n        category\n        initiatedBy\n        direction\n        status\n        fiatAmount\n        asset {\n          id\n          logoUrl\n          symbol\n          name\n          __typename\n        }\n        assetAmount\n        ... on BuyTransaction {\n          assetPrice\n        }\n        ... on SellTransaction {\n          assetPrice\n        }\n        ... on DepositTransaction {\n          offer {\n            id\n          }\n        }\n        ... on WithdrawalTransaction {\n          offer {\n            id\n          }\n        }\n        ... on SwapTransaction {\n          childrenTransactions {\n            __typename\n            id\n            time\n            initiatedBy\n            direction\n            status\n            fiatAmount\n            assetAmount\n            asset {\n              logoUrl\n              symbol\n              name\n              __typename\n              id\n            }\n          }\n        }\n        ... on MergerCryptoTransaction {\n          childrenTransactions {\n            __typename\n            id\n            time\n            initiatedBy\n            direction\n            status\n            assetAmount\n            fiatAmount\n            finalRevenueShare\n            assetPrice\n            asset {\n              logoUrl\n              symbol\n              name\n              __typename\n              id\n            }\n            ... on MergerCryptoTransaction {\n              offer {\n                id\n              }\n            }\n          }\n        }\n        ... on BuyOrderTransaction {\n          __typename\n        }\n        ... on SellOrderTransaction {\n          __typename\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f778eb993c51c376f57260d0d660c22";

export default node;
